import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { DifficultyBarRow } from "./DifficultyBarHeader";
import { DifficultyBarBody } from "./DifficultyBarBody";

import type { DifficultyLevel, DifficultyLevelLimits } from "./DifficultyBar.utils";
import { getDifficultyBarTexts as defaultGetDifficultyBarTexts, getDifficultyLevel } from "./DifficultyBar.utils";
import { setFont } from "@similarweb/styles";
import { DIFFICULTY_LEVEL_WITH_LIMITS } from "app/common/difficulty/difficulty.utils";

const DifficultyBarFooter = styled.div`
    ${setFont({ $color: colorsPalettes.carbon["400"], $size: 14 })};
    line-height: 20px;
`;

const DifficultyBarHeaderWrapper = styled.div`
    margin-bottom: 10px;
`;

type DifficultyBarProps = {
    difficultyLevelsWithLimits?: Record<DifficultyLevel, DifficultyLevelLimits>;
    difficultyGrade: number;
    country: string;
    getDifficultyBarTexts?: typeof defaultGetDifficultyBarTexts;
};

export const DifficultyBar = ({
    difficultyGrade,
    difficultyLevelsWithLimits = DIFFICULTY_LEVEL_WITH_LIMITS,
    country,
    getDifficultyBarTexts = defaultGetDifficultyBarTexts,
}: DifficultyBarProps) => {
    const difficultyLevel = getDifficultyLevel(difficultyGrade, difficultyLevelsWithLimits);
    const translate = useTranslation();
    const { labelText, easyLevelText, difficultLabelText, disclaimerText } = getDifficultyBarTexts(
        translate,
        difficultyLevel,
        country,
    );

    return (
        <>
            <DifficultyBarHeaderWrapper>
                <DifficultyBarRow
                    difficultyLevel={difficultyLevel}
                    difficultyGrade={difficultyGrade}
                    labelText={labelText}
                />
            </DifficultyBarHeaderWrapper>
            <DifficultyBarBody
                difficultyLevel={difficultyLevel}
                difficultyGrade={difficultyGrade}
                easyLevelText={easyLevelText}
                difficultLabelText={difficultLabelText}
            />
            <DifficultyBarFooter
                dangerouslySetInnerHTML={{
                    __html: disclaimerText,
                }}
            />
        </>
    );
};
